import { StatusBadge, kitStatus } from "../../StatusBadge";
import { AiCost } from "../AiCost";
import { PublishButton } from "../PublishButton";
import { DeleteKitButton } from "../DeleteKitButton";

const MODELS = { "claude-sonnet-5-5": "Claude Sonnet 5.5", "claude-opus-5-5": "Claude Opus 5.5", "claude-sonnet-4-5-20250929": "Claude Sonnet 4.5" };
const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "numeric", year: "numeric" }) : "");

const Eyebrow = ({ kit, c, pdfOnly }) => (
  <div data-testid="kit-eyebrow" className="font-mono-ui text-[11px] tracking-[0.22em] uppercase text-[#2B2A26]/80 flex flex-wrap items-center gap-x-2">
    {kit.bespoke ? <span data-testid="kit-bespoke-label">Bespoke for {kit.bespoke.name} · {kit.collection === "founders" ? "Founder's layout" : "Researched layout"}</span>
      : <span>{({ founders: "Founder's Collection", standalone: `Standalone · ${kit.topic}`, guide: "One-off Guide" })[kit.collection] || "Researched"}</span>}
    <span>· {kit.edition} edition{pdfOnly ? "" : ` · ${kit.tier} · ${kit.days} days`}</span>
    <span>· Edition {kit.accuracy?.number || 1}</span>
    <span className="inline-flex items-center gap-1 normal-case tracking-normal text-[11px] text-stone-500">
      <span className="h-2.5 w-2.5" style={{ background: c.dark }} /><span className="h-2.5 w-2.5" style={{ background: c.primary }} /> <span data-testid="kit-model-label">{MODELS[kit.model] || kit.model || "AI writer"}</span>
    </span>
  </div>
);

export const KitHeader = ({ kit, c, busy, reload, pdfOnly }) => {
  const live = kit.product?.published;
  const hasContent = kit.sections?.length > 0;
  return (
    <header data-testid="kit-header" className="rise relative border-l-4 px-8 py-7 mb-8" style={{ background: c.band, borderColor: c.primary }}>
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div className="min-w-0">
          <Eyebrow kit={kit} c={c} pdfOnly={pdfOnly} />
          <h1 data-testid="kit-title" className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2B2A26] mt-3 leading-tight">{kit.destination}</h1>
          <div className="flex flex-wrap items-center gap-3 mt-3">
            <StatusBadge status={kitStatus(kit)} testId="kit-detail-status" />
            <span data-testid="kit-tagline" className="font-display italic text-stone-600">{kit.meta?.tagline || (pdfOnly ? (kit.subjects || []).join(" · ") : kit.season)}</span>
            {!busy && <AiCost cost={kit.ai_cost} />}
          </div>
        </div>
        <div className="flex items-start gap-2">
          <div className="text-right">
            <div className="flex flex-wrap justify-end gap-2"><PublishButton kit={kit} reload={reload} disabled={!hasContent || busy || kit.filling} /></div>
            {live && <div data-testid="kit-live-meta" className="text-[11px] text-stone-500 mt-1.5">Live on store · Edition {kit.accuracy?.number || 1} · {fmt(kit.product.published_at)}</div>}
            {live && kit.product?.slug && <a data-testid="kit-public-link" href={`/catalog?kit=${kit.product.slug}`} target="_blank" rel="noreferrer" className="text-[11px] text-stone-600 hover:text-[#2B2A26]">Public catalogue page ↗</a>}
          </div>
          <DeleteKitButton kit={kit} />
        </div>
      </div>
    </header>
  );
};
